// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2OmOj","itemTitle":"ClientEmergencyInfo_itemTitle__3XYXj","itemText":"ClientEmergencyInfo_itemText__3AATI"};